import { z } from 'zod';

const envSchema = z.object({
  // Acepta absolute URL (http(s)://...) o path relativo que arranca con `/`
  // (cuando el server proxy de vite intercepta `/api` → back externo).
  VITE_API_BASE_URL: z
    .string()
    .min(1)
    .refine(
      (v) => /^https?:\/\//i.test(v) || v.startsWith('/'),
      'Debe ser URL absoluta http(s) o path relativo iniciado con `/`',
    ),
  VITE_SENTRY_DSN: z.string().optional().default(''),
  VITE_SENTRY_ENV: z
    .enum(['development', 'staging', 'production'])
    .optional()
    .default('development'),
  VITE_USE_MSW: z
    .string()
    .optional()
    .default('false')
    .transform((v) => v === 'true'),
  // CSV opcional de slugs permitidos por el backend en uso. Si está set,
  // `@/config/sources` filtra cualquier slug fuera de este set en los
  // schemas y defaults para evitar 400 del back ("Sources inválidos en
  // /foo: [vtex]"). Vacío/no set → no filtra (default prod).
  VITE_AVAILABLE_SOURCES: z
    .string()
    .optional()
    .default('')
    .transform((v) =>
      v
        .split(',')
        .map((s) => s.trim())
        .filter((s) => s.length > 0),
    ),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  // Fail fast en boot — la app NO debe arrancar con env inválido.
  // eslint-disable-next-line no-console
  console.error('[env] Variables de entorno inválidas:', parsed.error.flatten().fieldErrors);
  throw new Error('Variables de entorno inválidas — revisar .env');
}

export const env = parsed.data;
